export const TEST_ID = 'applyFromApplicationRoute';
